module.exports = __webpack_public_path__ + "static/media/cat-profile.93cbf0a6.png";